module.exports = __webpack_public_path__ + "media/src/images/partners/salford-4220eea0d1ea5186206d1e5f1a76c686.jpg";